'use strict';
/* eslint-env browser */

var _slicedToArray = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Multiaddr = require('multiaddr');

var _require = require('ipfs-utils/src/env'),
    isBrowser = _require.isBrowser,
    isWebWorker = _require.isWebWorker,
    isNode = _require.isNode;

var _require2 = require('parse-duration'),
    parseDuration = _require2.default;

var log = require('debug')('ipfs-http-client:lib:error-handler');

var HTTP = require('ipfs-utils/src/http');

var merge = require('merge-options');

var toUrlString = require('ipfs-core-utils/src/to-url-string');

var http = require('http');

var https = require('https');

var DEFAULT_PROTOCOL = isBrowser || isWebWorker ? location.protocol : 'http';
var DEFAULT_HOST = isBrowser || isWebWorker ? location.hostname : 'localhost';
var DEFAULT_PORT = isBrowser || isWebWorker ? location.port : '5001';
/**
 * @param {ClientOptions|URL|Multiaddr|string} [options]
 * @returns {ClientOptions}
 */

var normalizeOptions = function normalizeOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url;
  var opts = {};
  var agent;

  if (typeof options === 'string' || Multiaddr.isMultiaddr(options)) {
    url = new URL(toUrlString(options));
  } else if (options instanceof URL) {
    url = options;
  } else if (typeof options.url === 'string' || Multiaddr.isMultiaddr(options.url)) {
    url = new URL(toUrlString(options.url));
    opts = options;
  } else if (options.url instanceof URL) {
    url = options.url;
    opts = options;
  } else {
    opts = options || {};
    var protocol = (opts.protocol || DEFAULT_PROTOCOL).replace(':', '');
    var host = (opts.host || DEFAULT_HOST).split(':')[0];
    var port = opts.port || DEFAULT_PORT;
    url = new URL("".concat(protocol, "://").concat(host, ":").concat(port));
  }

  if (opts.apiPath) {
    url.pathname = opts.apiPath;
  } else if (url.pathname === '/' || url.pathname === undefined) {
    url.pathname = 'api/v0';
  }

  if (isNode) {
    var Agent = url.protocol.startsWith('https') ? https.Agent : http.Agent;
    agent = opts.agent || new Agent({
      keepAlive: true,
      // Similar to browsers which limit connections to six per host
      maxSockets: 6
    });
  }

  return _objectSpread({}, opts, {
    host: url.host,
    protocol: url.protocol.replace(':', ''),
    port: Number(url.port),
    apiPath: url.pathname,
    url: url,
    agent: agent
  });
};

var errorHandler =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(response) {
    var msg, data, error;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!(response.headers.get('Content-Type') || '').startsWith('application/json')) {
              _context.next = 9;
              break;
            }

            _context.next = 4;
            return response.json();

          case 4:
            data = _context.sent;
            log(data);
            msg = data.Message || data.message;
            _context.next = 12;
            break;

          case 9:
            _context.next = 11;
            return response.text();

          case 11:
            msg = _context.sent;

          case 12:
            _context.next = 18;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](0);
            log('Failed to parse error response', _context.t0); // Failed to extract/parse error message from response

            msg = _context.t0.message;

          case 18:
            /** @type {Error} */
            error = new HTTP.HTTPError(response); // This is what go-ipfs returns where there's a timeout

            if (msg && msg.includes('context deadline exceeded')) {
              error = new HTTP.TimeoutError(response);
            } // This also gets returned


            if (msg && msg.includes('request timed out')) {
              error = new HTTP.TimeoutError(response);
            } // If we managed to extract a message from the response, use it


            if (msg) {
              error.message = msg;
            }

            throw error;

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 14]]);
  }));

  return function errorHandler(_x) {
    return _ref.apply(this, arguments);
  };
}();

var KEBAB_REGEX = /[A-Z\u00C0-\u00D6\u00D8-\u00DE]/g;

var kebabCase = function kebabCase(str) {
  return str.replace(KEBAB_REGEX, function (match) {
    return '-' + match.toLowerCase();
  });
};

var parseTimeout = function parseTimeout(value) {
  return typeof value === 'string' ? parseDuration(value) : value;
};
/**
 * @typedef {import('http').Agent} HttpAgent
 * @typedef {import('https').Agent} HttpsAgent
 *
 * @typedef {Object} ClientOptions
 * @property {string} [host]
 * @property {number} [port]
 * @property {string} [protocol]
 * @property {Headers|Record<string, string>} [headers] - Request headers.
 * @property {number|string} [timeout] - Amount of time until request should timeout in ms or humand readable. https://www.npmjs.com/package/parse-duration for valid string values.
 * @property {string} [apiPath] - Path to the API.
 * @property {URL|string|Multiaddr} [url] - Full API URL.
 * @property {object} [ipld]
 * @property {any[]} [ipld.formats] - An array of additional [IPLD formats](https://github.com/ipld/interface-ipld-format) to support
 * @property {(format: string) => Promise<any>} [ipld.loadFormat] - an async function that takes the name of an [IPLD format](https://github.com/ipld/interface-ipld-format) as a string and should return the implementation of that codec
 * @property {HttpAgent|HttpsAgent} [agent] - A [http.Agent](https://nodejs.org/api/http.html#http_class_http_agent) used to control connection persistence and reuse for HTTP clients (only supported in node.js)
 */


var Client =
/*#__PURE__*/
function (_HTTP) {
  _inherits(Client, _HTTP);

  /**
   * @param {ClientOptions|URL|Multiaddr|string} [options]
   */
  function Client() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Client);

    var opts = normalizeOptions(options);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Client).call(this, {
      timeout: parseTimeout(opts.timeout) || 60000 * 20,
      headers: opts.headers,
      base: "".concat(opts.url),
      handleError: errorHandler,
      transformSearchParams: function transformSearchParams(search) {
        var out = new URLSearchParams(); // @ts-ignore https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = search[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref4 = _step.value;

            var _ref3 = _slicedToArray(_ref4, 2);

            var key = _ref3[0];
            var value = _ref3[1];

            if (value !== 'undefined' && value !== 'null' && key !== 'signal') {
              out.append(kebabCase(key), value);
            } // @ts-ignore server timeouts are strings


            if (key === 'timeout' && !isNaN(value)) {
              out.append(kebabCase(key), value);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return out;
      },
      // @ts-ignore this can be a https agent or a http agent
      agent: opts.agent
    })); // @ts-ignore

    delete _this.get; // @ts-ignore

    delete _this.put; // @ts-ignore

    delete _this.delete; // @ts-ignore

    delete _this.options;
    var fetch = _this.fetch;

    _this.fetch = function (resource) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof resource === 'string' && !resource.startsWith('/')) {
        resource = "".concat(opts.url, "/").concat(resource);
      }

      return fetch.call(_assertThisInitialized(_this), resource, merge(options, {
        method: 'POST'
      }));
    };

    return _this;
  }

  return Client;
}(HTTP);

Client.errorHandler = errorHandler;
module.exports = Client;